import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

function PricingPlans() {
  const [isYearly, setIsYearly] = useState(false);

  const togglePricing = () => {
    setIsYearly(!isYearly);
  };

  const [plans] = useState([
    {
      title: "Standard",
      monthly: 19.99,
      yearly: 69.99,
      img: "priching-img-1.png",
      features: [
        "Limited access for a month",
        "15 customize sub page",
        "105 disk space",
        "3 domain access",
        "24/7 phone support",
      ],
    },
    {
      title: "Premium",
      monthly: 49.99,
      yearly: 159.99,
      img: "priching-img-2.png",
      features: [
        "Unlimited access for a month",
        "25 customize sub page",
        "150 disk space",
        "5 domain access",
        "24/7 phone support",
      ],
    },
    {
      title: "Unlimited",
      monthly: 69.99,
      yearly: 259.99,
      img: "priching-img-3.png",
      features: [
        "Limited access for a month",
        "15 customize sub page",
        "120 disk space",
        "5 domain access",
        "24/7 phone support",
      ],
    },
  ]);

  return (
    <section id="pricing" className="pricing-section ptb-100 gray-light-bg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-9 col-lg-8">
            <div className="section-heading text-center mb-4">
              <h2>Our Flexible Price</h2>
              <p>
                Professional hosting at an affordable price. Distinctively
                recaptiualize principle-centered core competencies through
                client-centered core competencies.
              </p>
            </div>
          </div>
        </div>

        <div className="row align-items-center justify-content-md-center justify-content-center">
          <div className="col-12">
            <div className="d-flex justify-content-center text-center">
              <label className="pricing-switch-wrap">
                <span
                  className={`beforeinput year-switch ${
                    isYearly ? "color-accent" : "text-white"
                  }`}
                >
                  Monthly
                </span>
                <input
                  type="checkbox"
                  className="d-none"
                  checked={isYearly}
                  onChange={togglePricing}
                />
                <span className="switch-icon"></span>
                <span
                  className={`afterinput year-switch ${
                    isYearly ? "text-white" : "color-accent "
                  }`}
                >
                  Yearly
                </span>
              </label>
            </div>
          </div>

          {plans.map((plan, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-8">
              <div
                className={`text-center bg-white single-pricing-pack mt-4 ${
                  plan.title === "Premium" ? "popular-price" : ""
                }`}
              >
                <div className="price-img pt-4">
                  <img
                    src={`/assets/img/${plan.img}`}
                    alt="price"
                    width="120"
                    className="img-fluid"
                  />
                </div>
                <div className="py-4 border-0 pricing-header">
                  <div className="price text-center mb-0 color-secondary">
                    ${isYearly ? plan.yearly : plan.monthly}
                    <span>.99</span>
                  </div>
                </div>
                <div className="price-name">
                  <h5 className="mb-0">{plan.title}</h5>
                </div>
                <div className="pricing-content">
                  <ul className="list-unstyled mb-4 pricing-feature-list">
                    {plan.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                  <a
                    href="#"
                    className="btn btn-outline-brand-02 btn-rounded mb-3"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Purchase now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PricingPlans;
